import { Badge, Col, Popover, Row, Tag } from "antd";
import React, { useState } from "react";
import {
  DollarCircleTwoTone,
  IdcardTwoTone,
  LeftOutlined,
  PictureTwoTone,
  SnippetsTwoTone,
  ToolTwoTone,
} from "@ant-design/icons";

import NavigationService from "services/navigation";

import TimerCard from "components/cards/timer";
import Premiums from "components/premiums";
import ClientCard from "components/cards/client";
import Notes from "components/notes";
import Photos from "components/cards/photos";
import Utilities from "components/cards/utilities";
import Close from "./close";
import { observer } from "mobx-react";

function Toolbar({ chat }) {
  const [openNotes, setOpenNotes] = useState(false);
  const [openPhotos, setOpenPhotos] = useState(false);
  const [openPremiums, setOpenPremiums] = useState(false);
  const [openUtilities, setOpenUtilities] = useState(false);
  const [openClient, setOpenClient] = useState(false);

  const { isOnline, type } = chat;

  const hide = () => {
    setOpenNotes(false);
    setOpenPhotos(false);
    setOpenPremiums(false);
    setOpenUtilities(false);
    setOpenClient(false);
  };

  const goBack = () => {
    NavigationService.navigate(-1);
  };

  return (
    <Row>
      <LeftOutlined
        style={{ fontSize: 30, color: "var(--adm-color-primary)" }}
        onClick={goBack}
      />
      {type === "realtime" && (
        <>
          <Row>
            <Col>
              <Tag color={isOnline ? "green" : "red"}>
                {isOnline ? "online" : "offline"}
              </Tag>
            </Col>
            <TimerCard
              warning={!!chat.beDestroyedAt}
              date={chat.beDestroyedAt || chat.startedAt}
            />
          </Row>
        </>
      )}
      <Row justify="end" align="middle" style={{ flex: 1 }} gutter={10}>
        <Col>
          <Popover
            trigger="click"
            open={openNotes}
            onOpenChange={(value) => setOpenNotes(value)}
            content={
              <>
                <Close onClose={hide} />
                <Notes
                  contactId={chat.contact.id}
                  onAdd={chat.contact.addNote}
                  onDelete={chat.contact.deleteNote}
                  onUpdate={chat.contact.updateNote}
                  notes={chat.contact.notes}
                />
              </>
            }
          >
            <SnippetsTwoTone
              style={{
                fontSize: 30,
                color: "var(--adm-color-primary)",
              }}
            />
          </Popover>
        </Col>
        <Col>
          <Popover
            trigger="click"
            open={openPhotos}
            onOpenChange={(value) => setOpenPhotos(value)}
            content={
              <>
                <Close onClose={hide} />
                <Photos photos={chat.contact.photos} />
              </>
            }
          >
            <PictureTwoTone
              style={{
                fontSize: 30,
                color: "var(--adm-color-primary)",
              }}
            />
          </Popover>
        </Col>
        <Col>
          <Popover
            trigger="click"
            open={openPremiums}
            onOpenChange={(value) => setOpenPremiums(value)}
            content={
              <>
                <Close onClose={hide} />
                <Premiums
                  contactId={chat.contact.id}
                  premiumPurchases={chat.contact.premiumPurchases}
                  soldPremiumPurchases={chat.contact.soldPremiumPurchases}
                  onChange={chat.contact.updatePremiumPurchase}
                />
              </>
            }
          >
            <Badge
              count={`${chat.contact.premiumPurchases.length}/${chat.contact.soldPremiumPurchases.length}`}
            >
              <DollarCircleTwoTone
                style={{
                  fontSize: 30,
                  color: "var(--adm-color-primary)",
                }}
              />
            </Badge>
          </Popover>
        </Col>
        <Col>
          <Popover
            trigger="click"
            open={openUtilities}
            onOpenChange={(value) => setOpenUtilities(value)}
            content={
              <>
                <Close onClose={hide} />
                <Utilities
                  addTrialMinutes={chat.addTrialMinutes}
                  tag={chat.tag}
                  updateTag={chat.updateTag}
                />
              </>
            }
          >
            <ToolTwoTone
              style={{ fontSize: 30, color: "var(--adm-color-primary)" }}
            />
          </Popover>
        </Col>
        <Col>
          <Popover
            trigger="click"
            open={openClient}
            onOpenChange={(value) => setOpenClient(value)}
            content={
              <>
                <Close onClose={hide} />
                <ClientCard client={chat.contact} />
              </>
            }
          >
            <IdcardTwoTone
              style={{ fontSize: 30, color: "var(--adm-color-primary)" }}
            />
          </Popover>
        </Col>
      </Row>
    </Row>
  );
}

export default observer(Toolbar);
